'use client'
import { Col, LoadMoreSection, Skeleton } from '@repo/ui/components'
import { ProjectsCardItem } from './projects.card-item'
import { FiltersContainer } from '@/components/common/filters'
import { useListProjects } from '@repo/services'
import { ProjectsEmptyState } from './projects.empty-state'
import { useDebounce } from '@repo/ui/hooks'
import { useFiltersStore } from '@repo/shared/store'
import { cn } from '@repo/ui/lib'

export const ProjectsContainer = () => {
  const { setFilters, resetFilters } = useFiltersStore()
  const filters = useFiltersStore((state) => state.filters)

  const debouncedSearch = useDebounce(filters.search, 400) || ''
  const {
    data,
    fetchNextPage,
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    isFetched,
  } = useListProjects({
    skip: 0,
    limit: 10,
    kind: 'crypto',
    // provinceID: 123,
    ...(filters.orderBy &&
      filters.orderBy !== 'default' && {
        orderBy: filters.orderBy,
      }),
    ...(filters.priceMin && {
      priceMin: filters.priceMin * 10,
    }),
    ...(filters.priceMax && {
      priceMax: filters.priceMax * 10,
    }),
    // ...(filters.city &&
    //   filters.city !== 'all' && {
    //     cityID: +filters.city,
    //   }),
    // ...(filters.neighborhood &&
    //   filters.city !== 'all' && {
    //     districtID: +filters.neighborhood,
    //   }),
    ...(filters.city &&
      filters.city !== 'all' && {
        countyID: +filters.city,
      }),
    ...(filters.neighborhood &&
      filters.neighborhood !== 'all' && {
        districtID: +filters.neighborhood,
      }),
    ...(filters.usage &&
      filters.usage !== 'all' && {
        type: filters.usage,
      }),
    ...(filters.state &&
      filters.state !== 'all' && {
        state: filters.state,
      }),
    ...(filters.search && {
      q: debouncedSearch,
    }),
  })

  const projects =
    data?.pages.flatMap((page) => page.data?.projects || []) || []

  return (
    <Col className='w-full max-w-container-md mx-auto mb-8xl md:mb-0'>
      <FiltersContainer filters={filters} onFiltersChange={setFilters} />

      <div
        className={cn(
          'pt-md md:px-md gap-md flex flex-wrap  items-stretch',
          filters.view === 'grid' ? 'flex-wrap' : 'flex-col',
        )}
      >
        {!isFetched && (
          <>
            <Skeleton className='h-24 w-full' />
            <Skeleton className='h-24 w-full' />
          </>
        )}

        {projects?.map((project) => (
          <ProjectsCardItem
            key={project.id}
            project={project}
            viewType={filters.view}
          />
        ))}
        {isLoading && (
          <Col className='gap-md px-md'>
            {Array.from({ length: 10 }).map((_, index) => (
              <Skeleton
                key={index}
                className='w-full h-20  bg-neutral-surface-light rounded-md '
              />
            ))}
          </Col>
        )}
        {/* Loading trigger element */}
        <LoadMoreSection
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          isLoading={isLoading}
        />

        {projects.length === 0 && !isLoading && (
          <ProjectsEmptyState
            onReset={() => resetFilters()}
            isLoading={isLoading}
          />
        )}
      </div>
    </Col>
  )
}
